import { useCallback, useEffect, useMemo, useState } from 'react'
import { useCreateDraftConfiguredServiceContext } from 'components/configured-service/CreateDraftConfiguredServiceDialog/CreateDraftConfiguredServiceContext'
import { useLazyGetAccountDetailsQuery } from 'api/accounts/getAccountDetails'
import { get } from 'lodash'
import { selectAddress } from 'data/address/addressSelectors'
import { INITIAL_CAMERA } from 'components/configured-service/hooks/useConfiguredServiceMapData'

export function useScheduleMapAndLocation() {
  const { accountId, getValues } = useCreateDraftConfiguredServiceContext()
  const [getAccountDetails, { data: accountDetailsData, isFetching: isAccountFetching }] = useLazyGetAccountDetailsQuery()

  const locationFormValue = getValues('location')
  const locationId = locationFormValue?.id || locationFormValue?.value

  useEffect(() => {
    if (accountId) {
      getAccountDetails({ accountId })
    }
  }, [accountId])

  const selectedLocation = useMemo(() => {
    if (!locationId) return null
    const locations = get(accountDetailsData, 'locations', [])
    return locations.find(l => l.id === locationId) || null
  }, [locationId, accountDetailsData])

  const { latitude, longitude } = useMemo(() => {
    if (!selectedLocation) return { latitude: undefined, longitude: undefined }
    const { latitude: lat, longitude: lng } = selectAddress(selectedLocation?.address)
    return { latitude: lat, longitude: lng }
  }, [selectedLocation])

  const [mapCenter, setMapCenter] = useState(INITIAL_CAMERA.center)
  const handleMapCenterChange = useCallback(center => {
    setMapCenter(center)
  }, [])

  return { latitude, longitude, mapCenter, handleMapCenterChange, isLoading: isAccountFetching }
}
